import { z } from 'zod';
import { Navigate, useLocation } from 'react-router';
import React from 'react';
import { UnauthenticatedApplicationContext } from '@varos/client-base';
import { AssistantContainerBaseConfig } from '../../base';
import { AssistantLinkController, AssistantLinkLoader } from './interviewLinkInterface';
import { AssistantLinkContainerProps } from './interviewLinkProps';

export function createLinkContainer(
    config: AssistantContainerBaseConfig,
    loader: AssistantLinkLoader,
    controller: AssistantLinkController
): React.FC<AssistantLinkContainerProps> {
    const {
        kernel: {
            infra: {
                optionParser: { useOptions },
            },
        },
        adapter,
    } = config;

    const PageParamsSchema = z.object({
        token: z.string(),
    });

    const context: UnauthenticatedApplicationContext = {
        principal: null,
    };

    return ({ ...containerProps }) => {
        const location = useLocation();
        const options = useOptions(PageParamsSchema);
        if (options instanceof Error) {
            console.error('invalid link params, redirecintg to home', options);
            return <Navigate to={config.navigation.home.path} replace={true} />;
        }
        const item = loader.useLoad(context, options);
        const props = controller.useProps(item, { location });
        console.log('navigating to', props.redirect);
        return <Navigate {...props.redirect} />;
    };
}
